import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="answer-selection"
// Handles clicking on answer choice circles (A-E) for questions
export default class extends Controller {
  static values = {
    letter: String,
    qnumber: Number
  }

  click(event) {
    event.preventDefault()

    const $ = window.$
    if (!$) {
      console.warn('[answer-selection] jQuery not available')
      return
    }

    const letter = this.letterValue || this.element.getAttribute('data-letter')
    const questionNumber = this.qnumberValue || this.element.getAttribute('data-qnumber')

    if (!letter || !questionNumber) {
      console.warn('[answer-selection] Missing letter or question number', { letter, questionNumber })
      return
    }

    // Check if already selected (has filled-green class)
    if ($(this.element).hasClass("interface-filled-green-yash")) {
      this.unclickAnswer()
    } else {
      this.clickAnswer()
    }

    // Hide the line in the clicked circle
    $(this.element).find(".interface-line-yash").css("display", "none")
  }

  clickAnswer() {
    const $ = window.$
    const letter = this.letterValue || this.element.getAttribute('data-letter')
    const questionNumber = this.qnumberValue || this.element.getAttribute('data-qnumber')
    const bubbleIndex = parseInt(questionNumber) - 1

    // Remove filled-green from siblings
    $(this.element).siblings().removeClass("interface-filled-green-yash")
    // Add filled-green to clicked bubble
    $(this.element).addClass("interface-filled-green-yash")
    // Add black class to bottom bubble
    $(".interface-bottom-bubble-yash:eq(" + bubbleIndex + ")").addClass("interface-black-yash")

    // Hide line in clicked bubble
    $(this.element).find(".interface-line-yash").css("display", "none")

    // Update form input
    const formAnswer = $("#question" + questionNumber + "-yash")
    formAnswer.val(letter)

    // Update elimination circle - show line and reset clicked state
    const eliminator = $("#interface-questions-container-holder-" + questionNumber + "-yash")
      .find(".interface-elimination-circle-yash")
      .filter(function() {
        return $(this).attr("data-letter") == letter
      })
    eliminator.find(".interface-line-yash").css("display", "block")
    eliminator.attr("data-clicked", 0)
  }

  unclickAnswer() {
    const $ = window.$
    const questionNumber = this.qnumberValue || this.element.getAttribute('data-qnumber')
    const bubbleIndex = parseInt(questionNumber) - 1

    if ($(this.element).hasClass("interface-filled-green-yash")) {
      // Remove filled-green from this and siblings
      $(this.element).removeClass("interface-filled-green-yash")
      $(this.element).siblings().removeClass("interface-filled-green-yash")
      // Remove black class from bottom bubble
      $(".interface-bottom-bubble-yash:eq(" + bubbleIndex + ")").removeClass("interface-black-yash")

      // Clear form input
      const formAnswer = $("#question" + questionNumber + "-yash")
      formAnswer.val("")
    }
  }
}

